export default __webpack_public_path__ + "static/media/08.1ff8a143.jpg";